export type XCoverTermsVariant = 'gb' | 'de';

type XCoverTermsLinks = {
  policyTerms: string;
  insuranceProductInformationDocument: string;
};

const XCOVER_TERMS_LINKS_BY_VARIANT: Record<XCoverTermsVariant, XCoverTermsLinks> = {
  gb: {
    policyTerms: 'https://www.xcover.com/en/pds/NFQTL-QW8KL-INS',
    insuranceProductInformationDocument: 'https://static.xcover.com/media/pds/12dc93b1-92e0-4902-9cf7-5e566e6affd3/IPID_Shipping_UK.pdf',
  },
  de: {
    policyTerms: 'https://www.xcover.com/de/pds/23JZM-22GMY-INS',
    insuranceProductInformationDocument: 'https://static.xcover.com/media/pds/29783625-b687-47fc-a2e6-a692154dd5c8/IPID_ShipStation_DE.pdf',
  },
};

export const getXCoverTermsLinks = (variant?: string): XCoverTermsLinks | undefined =>
  variant ? XCOVER_TERMS_LINKS_BY_VARIANT[variant as XCoverTermsVariant] : undefined;
